import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../state";
import { RootState } from "../../state";
import { DefaultButton, Dialog, DialogType, Label, Stack, StackItem, TextField, IconButton } from "@fluentui/react";
import { getAnydayQRCodes, upsetAnydayQRCode, deleteAnydayQRCode } from "../../state/department/anydayQRCode";
import { getDepartments } from "../../state/action";

interface Props {
    departmentId?: string;
}

const AnydayQRCode = (props: Props) => {
    const [editMode, setEditMode] = React.useState(false);
    const dispatch = useDispatch<AppDispatch>() as any;

  
    const departments = useSelector((state: RootState) => getDepartments(state));
    const [id, setId] = React.useState<string | undefined>(undefined);
    const [name, setName] = React.useState<string | undefined>(undefined);
    const [qrCodeId, setQRCodeId] = React.useState<string | undefined>(undefined);
    const department = departments.find(x => x.id === props.departmentId);
    const editAnydayQRCode = () => {
        setEditMode(!editMode);
        // Clear fields when closing
        if (editMode) {
            setName(undefined);
            setQRCodeId(undefined);
        }
    };

    React.useEffect(() => {
        if (props.departmentId) {
            dispatch(getAnydayQRCodes(props.departmentId));
        }
    }, [props.departmentId]);

    const onNameChange = (event: any, text?: string) => setName(text);
    const onQRCodeIdChange = (event: any, text?: string) => setQRCodeId(text);

    const upsetQrCode = () => {
        if (props.departmentId) {
            dispatch(upsetAnydayQRCode({id:id, departmentId: props.departmentId, name, qrCodeId: qrCodeId }));
            // Clear inputs after saving
            setName("");
            setQRCodeId("");
            setId(undefined);
        }
    };

    // 2. Load item into text fields for editing
    const startEdit = (item: AnydayQRCode) => {
        setName(item.name);
        setQRCodeId(item.qrCodeId);
        setId(item.id);
    };

    const removeQRCode = (id?: string) => {
        if (props.departmentId && id) {
            dispatch(deleteAnydayQRCode(id, props.departmentId));
        }
    };

    return (
        <div className="anyday-qr-code-manager">
            <Label onClick={editAnydayQRCode} className="anyday-qr-code-manager__title">
              QR Codes
            </Label>
            <DefaultButton onClick={editAnydayQRCode}>  Edit QR codes</DefaultButton>
            
            <Dialog
                minWidth={700}
                hidden={!editMode}
                onDismiss={editAnydayQRCode}
                dialogContentProps={{
                    type: DialogType.largeHeader,
                    title: "Anyday QRCodes",
                    showCloseButton: true
                }}
            >
                {/* INPUT SECTION */}
                <Stack horizontal={true} tokens={{ padding: 5, childrenGap: 10 }}>
                    <StackItem grow={1}>
                        <TextField label="Name" value={name} onChange={onNameChange} />
                    </StackItem>
                    <StackItem grow={1}>
                        <TextField label="QR Code ID" value={qrCodeId} onChange={onQRCodeIdChange} />
                    </StackItem>
                    <StackItem align="end">
                        <DefaultButton text="Save / Update" onClick={upsetQrCode} primary />
                    </StackItem>
                </Stack>

                <hr style={{ margin: '20px 0', border: '0.5px solid #eee' }} />

                {/* LIST SECTION */}
                <Stack tokens={{ childrenGap: 10 }}>
                    {department && department.anydayQRCodes && department.anydayQRCodes.map((item) => (
                        <Stack 
                            key={item.qrCodeId} 
                            horizontal 
                            verticalAlign="center" 
                            horizontalAlign="space-between"
                            styles={{ root: { padding: '10px', background: '#f3f2f1', borderRadius: '4px' }}}
                        >
                            <StackItem grow={1}>
                                <strong>{item.name}</strong> <span style={{ marginLeft: 10, color: '#666' }}>({item.qrCodeId})</span>
                            </StackItem>
                            
                            <Stack horizontal tokens={{ childrenGap: 5 }}>
                                <IconButton 
                                    iconProps={{ iconName: 'Edit' }} 
                                    title="Edit" 
                                    onClick={() => startEdit(item)} 
                                />
                                <IconButton 
                                    iconProps={{ iconName: 'Delete' }} 
                                    title="Delete" 
                                    styles={{ root: { color: 'red' }}}
                                    onClick={() => removeQRCode(item.id)} 
                                />
                            </Stack>
                        </Stack>
                    ))}
                </Stack>
            </Dialog>
        </div>
    );
};

export default AnydayQRCode;